import {StyledAccessesCounterCard, StyledAccessesCounterCardItem} from './style'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {UserCheck01Icon, UserX01Icon} from '@/components/ui/icon/Icon'
import {useTheme} from 'styled-components'
import {ProgressBar} from '@/components/ui/progress-bar/ProgressBar'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const AccessesCounterCardEmptyState = ({isLoading}: {isLoading: boolean}) => {
    const {t} = useTranslation()

    const {palette} = useTheme()

    return (
        <StyledAccessesCounterCard>
            <StyledAccessesCounterCardItem direction="column" gap={1} fullWidth>
                <Flexbox gap={1} align="center">
                    <UserCheck01Icon size={18} fill={palette.neutral[400]} />
                    <Text size="textXs">{t('projects:performed_in_presence_count')}</Text>
                </Flexbox>
                <Flexbox fullWidth justify="end">
                    {isLoading ? <Skeleton width={100} height={20} /> : <Text>-</Text>}
                </Flexbox>
                <ProgressBar rounded percentage={0} variant={'neutral'} />
            </StyledAccessesCounterCardItem>
            <Divider direction="vertical" />
            <StyledAccessesCounterCardItem direction="column" gap={1} fullWidth>
                <Flexbox gap={1} align="center">
                    <UserX01Icon size={18} fill={palette.neutral[400]} />
                    <Text size="textXs">{t('projects:performed_in_presence_count')}</Text>
                </Flexbox>
                <Flexbox fullWidth justify="end">
                    {isLoading ? <Skeleton width={100} height={20} /> : <Text>-</Text>}
                </Flexbox>
                <ProgressBar rounded percentage={0} variant={'neutral'} />
            </StyledAccessesCounterCardItem>
        </StyledAccessesCounterCard>
    )
}
